import React from 'react';
import Select from 'react-select';
import star_icon from '../../assets/images/icons/star-icon.png'





const VerticalSelectField = (props)=>{

    return (
    <div className="dashboard-textfield-container">
        <div className="dashboard-textfield-title">
            <span className="general-span-text">{props.title}</span>
            {props.required && <div >
                        <img src={star_icon}/>
                </div>}
        </div>
        <div className="vertical-select-field-ctn">
                <Select
                    value={props.selectedOption}
                    onChange={props.handleChange}
                    options={props.options}
                    className="vertical-select-field"
                    type={props.type}
                />
        </div>
    </div>
    );
}

export default VerticalSelectField